<div class="col-md-12 mt-5 text-center">
	<h1><strong>404</strong></h1>
	<h2 class="mb-4">{{'g.404' | translate}}</h2>
	<a href="/"><fa-icon icon="home" size="10x"></fa-icon></a>
</div>
